import { Injectable } from '@angular/core';
import { NgEntityService } from '@datorama/akita-ng-entity-service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { Building, Permission } from '../../model/building';
import { HttpOptions, UpdateActionType } from '../../service/generic-akita-http.service';
import { WebsocketService } from '../../service/websocket.service';
import { BuildingState, BuildingStore } from '../state/building.store';
import { AkitaBuildingHttpService } from './akita-building-http.service';
import { UrlConfig } from '../../model/urlconfig';


@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class BuildingService extends NgEntityService<BuildingState> implements UrlConfig {

  constructor(
    protected store: BuildingStore,
    private buildingHttpService: AkitaBuildingHttpService,
    private webSocketService: WebsocketService,
  ) {
    super(store);

    this.webSocketService.getDataStream('Building')
      .pipe(untilDestroyed(this))
      .subscribe((data: Building[]) => this.store.upsertMany(data));
  }

  updateEntitiesUrl(newUrl: string): void {
    this.buildingHttpService.setEntitiesUrl(newUrl);
  }

  getAll() {
    this.buildingHttpService.getAll().subscribe(buildings => this.store.add(
      // Temporarily remove the PKB test object
      buildings.filter(building => building.id !== 'urn:ngsi-ld:Building:d2d9b579-b23f-4e6a-a59c-3ae760f42a61')
    ));
  }

  requestBuildingPermission(building: Building) {
    const cloned: Partial<Building> = {
      id: building.id,
      type: building.type,
      permission: Permission.REQUEST
    };
    this.updateBuilding(cloned);
  }

  private updateBuilding(building: Partial<Building>) {
    this.store.upsert(building.id, building);
    const options: HttpOptions = {
      params: {
        options: 'keyValues'
      }
    };
    this.buildingHttpService.update(building, UpdateActionType.APPEND, options).subscribe(
      data => console.log('Updated Building', data),
      error => console.log('Error inserting in Hub', error)
    );
  }

}
